export default __webpack_public_path__ + "static/media/activity-14x12.cd23dbfd.svg";